<template>

  <div>
    <div v-if="!showDropdown">

      <b-img
        v-if="currentCompany.logo"
        :src="currentCompany.logo"
        height="36px"
        :alt="currentCompany.name"
      />
      <span v-else class="text-body font-weight-semibold">{{ currentCompany.name }}</span>
    </div>
    <b-nav-item-dropdown
      v-if="showDropdown"
      id="dropdown-grouped"
      variant="link"
      class="dropdown-language"
      right
    >
      <template #button-content>
        <b-img
          v-if="currentCompany.logo"
          :src="currentCompany.logo"
          height="36px"
          :alt="currentCompany.name"
        />
        <span class="ml-50 text-body">{{ currentCompany.name }}</span>
      </template>
      <b-dropdown-item
        v-for="company in companies"
        :key="company.id"
        @click="setCompany(company)"
      >
        <span>{{ company.name }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>

  </div>

</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import store from '@/store/index'
import { EventBus } from '@/utils/eventBus'
import UserService from '@/basic/userService'
import useJwt from '@/auth/jwt/useJwt'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      userCompany: JSON.parse(localStorage.getItem('userCompany')),
      companies: [],
    }
  },

  computed: {
    currentCompany() {
      // console.log("role",store.state.loggedUser.role)
      // return this.companies.find(l => l.id === this.userCompany.id)
      return this.userCompany
    },
    showDropdown() {
      const show = (this.userData && this.userData.role === 'admin')
      console.log('showDropdown', show)
      return show
    },
  },
  watch: {
    companies(newCompanies) {
      // Don't overwrite userCompany with compressed companies data
      // The userCompany should come from profile API which has complete data including logo
      console.log('Companies list updated, but keeping userCompany from profile API')
    },
  },

  mounted() {
    console.log('userData', this.userData)
    EventBus.$on('company-list-updated', () => {
      this.fetchCompanies()
    })

    // Load companies from storage or fetch if needed
    this.loadCompaniesFromStorage()

    // Ensure userCompany has complete data including logo
    this.ensureUserCompanyHasLogo()

    if (this.userData && this.userData.role === 'admin') {
      console.log('companies on array', this.companies)
    } else {
      console.log('not admin', this.userData)
    }
  },
  beforeDestroy() {
    EventBus.$off('company-list-updated')
  },

  methods: {
    ensureUserCompanyHasLogo() {
      // If userCompany doesn't have logo, fetch from company API
      if (this.userCompany && !this.userCompany.logo && this.userCompany.id) {
        console.log('UserCompany missing logo, fetching from company API')
        const expectedId = this.userCompany.id
        const userService = new UserService(useJwt)
        userService.company(expectedId).then(response => {
          // Skip if user has switched company since this request fired.
          if (!this.userCompany || this.userCompany.id !== expectedId) return
          if (response.data.data && response.data.data.company) {
            const companyData = response.data.data.company
            this.userCompany = companyData
            localStorage.setItem('userCompany', JSON.stringify(this.userCompany))
            store.commit('selected_company', companyData)
            console.log('Updated userCompany with logo from company API')
          }
        }).catch(error => {
          console.error('Failed to fetch company data for logo:', error)
        })
      }
    },

    loadCompaniesFromStorage() {
      const { safeLocalStorageGetItem } = require('@/utils/storageUtils')
      const storedCompanies = safeLocalStorageGetItem('companies', [])

      if (storedCompanies && storedCompanies.length > 0) {
        this.companies = storedCompanies
      } else if (this.userData && this.userData.role === 'admin') {
        // If no stored companies and user is admin, fetch from API
        this.fetchCompanies()
      }
    },

    fetchCompanies() {
      console.log('fetchCompanies because of event received company-list-updated')
      const userService = new UserService(useJwt)

      userService.companies({}).then(response => {
        const companies = response.data.data
        console.log('companies', companies)

        // Use safe storage to handle localStorage quota issues
        const { safeLocalStorageSetItem } = require('@/utils/storageUtils')
        const stored = safeLocalStorageSetItem('companies', companies)

        if (!stored) {
          console.warn('Companies data could not be stored in localStorage due to quota exceeded.')
        }

        this.companies = companies
        // Update your component's local state or Vuex store
      }).catch(error => {
        console.error('Failed to fetch companies:', error)
        // Handle error
      })
    },

    /**
     * CLIENT-02: after switching tenant, drop previous company's UI state.
     * List components refresh via Vuex `selected_company` subscribe.
     * Edit/detail pages snapshot userCompany in data() at mount and do NOT —
     * so we leave those routes and land on the dashboard.
     */
    applyCompanySwitch(companyData) {
      this.userCompany = companyData
      localStorage.setItem('userCompany', JSON.stringify(companyData))
      store.commit('selected_company', companyData)
      EventBus.$emit('company-switched', companyData)

      // Hard leave any entity screen of the previous company (employee, equipment, …).
      // NavigationDuplicated is fine if already on dashboard — lists still re-fetched via store.
      if (this.$router) {
        this.$router.push({ name: 'dashboard-ecommerce' }).catch(err => {
          if (err && err.name !== 'NavigationDuplicated') {
            console.warn('company switch navigation failed', err)
          }
        })
      }
      console.log('Company switch committed:', companyData && companyData.id)
    },

    setCompany(company) {
      console.log('Switching to company:', company)

      // Bump token so any in-flight switch response becomes stale and is dropped.
      this._switchToken = (this._switchToken || 0) + 1
      const myToken = this._switchToken

      // Same company → no-op
      if (this.userCompany && company && String(this.userCompany.id) === String(company.id)) {
        return
      }

      const userService = new UserService(useJwt)
      userService.company(company.id).then(response => {
        if (myToken !== this._switchToken) {
          console.log('stale company switch response, ignoring', company.id)
          return
        }
        const companyData = (response.data && response.data.data && response.data.data.company)
          ? response.data.data.company
          : company
        this.applyCompanySwitch(companyData)
      }).catch(error => {
        if (myToken !== this._switchToken) return
        console.log('Company API fetch failed; falling back to lightweight data:', error)
        this.applyCompanySwitch(company)
      })
    },
  },

}
</script>

<style>
.navbar-nav .dropdown-menu {
  overflow: auto;
  max-width: 500px;
  height: auto;
  max-height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
